import React from "react";

/**
 * Flat RaceSnap logo – camera body + runner silhouette + motion lines.
 * No gradients, no shadows.
 */
export default function Logo({ className = "", size = 28, withText = true }) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid="rs-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        {/* Camera body */}
        <rect x="4" y="13" width="40" height="28" rx="2" fill="#111827" />
        {/* Lens housing white */}
        <rect x="4" y="13" width="40" height="6" fill="#5B4CFF" />
        {/* Top bump */}
        <rect x="16" y="8" width="14" height="6" fill="#5B4CFF" />
        {/* Lens circle */}
        <circle cx="30" cy="29" r="8" fill="#FFFFFF" />
        <circle cx="30" cy="29" r="4" fill="#5B4CFF" />
        {/* Runner silhouette inside lens */}
        <path
          d="M28.2 25.5 l1.6 -1.6 l1.6 1.4 l-0.6 2.6 l1.4 1.4 l-0.4 2.4 l-1.6 -0.4 l-0.6 -2.2 l-1.6 -1 l-1 1.6 l-1.4 -0.6 z"
          fill="#FFFFFF"
        />
        {/* Motion lines */}
        <rect x="6" y="22" width="6" height="2" fill="#FFFFFF" />
        <rect x="4" y="27" width="8" height="2" fill="#FFFFFF" />
        <rect x="7" y="32" width="5" height="2" fill="#FFFFFF" />
      </svg>
      {withText && (
        <span className="font-display text-[1.15rem] font-extrabold tracking-tight text-[#0F172A]">
          Race<span className="text-[#5B4CFF]">Snap</span>
        </span>
      )}
    </div>
  );
}
